export default __webpack_public_path__ + "static/media/parking-spot-image.99c37d35.svg";